module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/plan01_beach-photo-0e4e9848196cece4fcbadf4767f497e2.jpg";